var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNswFdrCatastrophic = function SvgNswFdrCatastrophic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#FF2525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M15.277 2.55A10 10 0 0 0 11.9 2L22 12.1V12c0-1.148-.193-2.25-.55-3.277zM21.661 14.59 9.41 2.34a10 10 0 0 0-2.035.793l13.494 13.494c.335-.64.602-1.322.793-2.035M19.743 18.33 5.67 4.256q-.356.292-.683.613l-.118.118q-.322.327-.613.684l14.071 14.071q.777-.636 1.415-1.414M16.625 20.868 3.132 7.375a10 10 0 0 0-.793 2.035l12.25 12.251a10 10 0 0 0 2.036-.793M12.1 22 2 11.9v.1c0 1.148.194 2.251.55 3.278L8.72 21.45A10 10 0 0 0 12.1 22"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    fill: "#FF2525"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5,
    fill: "#21272C"
  })));
};
export default SvgNswFdrCatastrophic;